import { DivConst } from 'constants/divConst';
import { openProductionUrl as openDiagnosisProductionUrl } from './diagnosis';
import { openLineProductionUrl as openDiagnosisLineProductionUrl } from './diagnosis';
import { openProductionUrl as openFormProductionUrl } from './form';
import { openLineProductionUrl as openFormLineProductionUrl } from './form';
import { openProductionUrl as openQuizProductionUrl } from './quiz';
import { openLineProductionUrl as openQuizLineProductionUrl } from './quiz';

/**
 * コンテンツタイプ文字列を取得します
 */
export function getContentsTypeStr(contentsTypeDiv: number): string {
  switch (contentsTypeDiv) {
    case DivConst.items.contentsType.quiz.value:
      return 'quiz';
    case DivConst.items.contentsType.diagnosis.value:
      return 'diagnosis';
    case DivConst.items.contentsType.form.value:
      return 'form';
    case DivConst.items.contentsType.voiceChat.value:
      return 'voice_chat';
    default:
      return '';
  }
}

/**
 * コンテンツタイプ文字列（和名）を取得します
 */
export function getContentsTypeStrJpn(contentsTypeDiv: number): string {
  switch (contentsTypeDiv) {
    case DivConst.items.contentsType.quiz.value:
      return 'クイズ';
    case DivConst.items.contentsType.diagnosis.value:
      return '診断';
    case DivConst.items.contentsType.form.value:
      return 'フォーム';
    case DivConst.items.contentsType.voiceChat.value:
      return 'ボイスチャット';
    default:
      return '';
  }
}

/**
 * コンテンツの公開URLを開きます。
 */
export function openProductionUrl(contentsCd: string, contentsTypeDiv: number): void {
  switch (contentsTypeDiv) {
    case DivConst.items.contentsType.quiz.value:
      openQuizProductionUrl(contentsCd);
      return;
    case DivConst.items.contentsType.diagnosis.value:
      openDiagnosisProductionUrl(contentsCd);
      return;
    case DivConst.items.contentsType.form.value:
      openFormProductionUrl(contentsCd);
      return;
    default:
      return;
  }
}

/**
 * コンテンツのLINE用公開URLを開きます。
 */
export function openLineProductionUrl(contentsCd: string, contentsTypeDiv: number): void {
  switch (contentsTypeDiv) {
    case DivConst.items.contentsType.quiz.value:
      openQuizLineProductionUrl(contentsCd);
      return;
    case DivConst.items.contentsType.diagnosis.value:
      openDiagnosisLineProductionUrl(contentsCd);
      return;
    case DivConst.items.contentsType.form.value:
      openFormLineProductionUrl(contentsCd);
      return;
    default:
      return;
  }
}

/**
 * ポップアップ埋め込みタグセクションへのスクロール
 */
export function handleScrollToPopupEmbed(e: React.MouseEvent<HTMLAnchorElement>): void {
  e.preventDefault();
  const target = document.querySelector('#popup-embed');
  if (target) {
    target.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
